var FORMS = {
  MESSAGE_ERROR: "has-text-danger",
  MESSAGE_OK: "has-text-success",
  init: function() {
    FORMS.initEnterKeyPress();
    FORMS.initInputFields();
  },

  initEnterKeyPress: function() {
    $(document).bind("keypress", function(event) {
      if (event.keyCode == 13) {
        var obj = $(document.activeElement);
        if (obj.attr("enter-event") != null) {
          eval(obj.attr("enter-event"));
          event.preventDefault();
          return false;
        }
      }
    });
  },
  // Detect inputs with default-value attribute, and process their focus/blur events; Detect fields that only allows some chars
  initInputFields: function() {
    $(":input").bind("focus", function() {
      FORMS.inputFocus(this, true);
    });
    $("select").on("select2:select", function(e) {
      $(this).removeClass("input-error");
    });
    $("*[default-value]").bind("blur", function() {
      FORMS.inputFocus(this, false);
    });
    $("input[input-type]").bind("keypress", function(ev) {
      return FORMS.inputRestrict(this, ev, $(this).attr("input-type"));
    });
    $("textarea[maxlength]").bind("input propertychange", function() {
      var maxLength = $(this).attr("maxlength");
      if ($(this).val().length > maxLength) {
        $(this).val(
          $(this)
            .val()
            .substring(0, maxLength)
        );
      }
    });
  },

  inputFocus: function(obj, flag) {
    if ($(obj).attr("default-value") != "") {
      if (flag) {
        if ($(obj).val() == $(obj).attr("default-value")) $(obj).val("");
      } else {
        if (UTILS.trim($(obj).val()) == "")
          $(obj).val($(obj).attr("default-value"));
      }
    }

    $(obj).removeClass("input-error");
  },

  inputRestrict: function(field, ev, type) {
    var key;
    var keychar;

    if (window.event) key = window.event.keyCode;
    else if (ev) key = ev.which;
    else return true;

    keychar = String.fromCharCode(key).toLowerCase();
    // control keys
    if (
      key == null ||
      key == 0 ||
      key == 8 ||
      key == 9 ||
      key == 13 ||
      key == 27
    ) {
      return true;
    } else {
      // specific type keys
      if (type == "phone" && "0123456789+/ ".indexOf(keychar) > -1) return true;
      else if (
        type == "email" &&
        "1234567890abcdefghijklmnopqrstuvwxyz@._-".indexOf(keychar) > -1
      )
        return true;
      else if (
        type == "url" &&
        "0123456789abcdefghijklmnopqrstuvwxyz:./@&?+=-,".indexOf(keychar) > -1
      )
        return true;
      else if (
        type == "alpha" &&
        "abcdefghijklmnopqrstuvwxyz".indexOf(keychar) > -1
      )
        return true;
      else if (
        type == "alphanumeric" &&
        "abcdefghijklmnopqrstuvwxyz0123456789-".indexOf(keychar) > -1
      )
        return true;
      else if (type == "number" && "-0123456789".indexOf(keychar) > -1)
        return true;
      else if (type == "decimal" && "-0123456789.".indexOf(keychar) > -1) {
        return true;
      }
    }
    return false;
  },

  checkText: function(val, type) {
    var text = UTILS.trim(val);

    if (text == "") return true;

    if (type == "alphanumeric") {
      var regexp = /^([a-zA-Z0-9\-]+)$/;
      return regexp.test(text.toLowerCase());
    } else if (type == "alpha") {
      var regexp = /^([a-zA-Z]+)$/;
      return regexp.test(text.toLowerCase());
    } else if (type == "number") {
      var regexp = /^([0-9\-]+)$/;
      if (regexp.test(text.toLowerCase())) {
        if (isNaN(text)) return false;
        return true;
      } else return false;
    } else if (type == "phone") {
      var regexp = /^([0-9\+\ ]+)$/;
      return regexp.test(text.toLowerCase());
    } else if (type == "decimal") {
      var regexp = /^([0-9\-.]+)$/;
      if (regexp.test(text.toLowerCase())) {
        if (isNaN(text)) return false;
        return true;
      } else return false;
    } else if (type == "email") {
      var regexp = /^((([a-z]|[0-9]|!|#|$|%|&|'|\*|\+|\-|\/|=|\?|\^|_|`|\{|\||\}|~)+(\.([a-z]|[0-9]|!|#|$|%|&|'|\*|\+|\-|\/|=|\?|\^|_|`|\{|\||\}|~)+)*)@((((([a-z]|[0-9])([a-z]|[0-9]|\-){0,61}([a-z]|[0-9])\.))*([a-z]|[0-9])([a-z]|[0-9]|\-){0,61}([a-z]|[0-9])\.)[\w]{2,6}|(((([0-9]){1,3}\.){3}([0-9]){1,3}))|(\[((([0-9]){1,3}\.){3}([0-9]){1,3})\])))$/;
      return regexp.test(text.toLowerCase());
    } else if (type == "url") {
      var regexp = /https?:\/\/([-\w\.]+)+(:\d+)?(\/([\w/_\.]*(\?\S+)?)?)?/;
      return regexp.test(text);
    }
    return true;
  },

  validateForm: function(form_id, msg_id) {
    $(msg_id).html("");
    var inputs = $(form_id).find(":input");
    var ok = true;

    for (var i = 0; i < inputs.length; i++) {
      if (
        $(inputs[i])
          .parent(".form-group")
          .css("display") == "none"
      )
        continue;

      if (
        $(inputs[i]).attr("mandatory") == 0 &&
        UTILS.trim($(inputs[i]).val()) == ""
      ) {
        $(inputs[i]).removeClass("input-error");
      } else {
        if (
          $(inputs[i]).attr("mandatory") == 1 &&
          (UTILS.trim($(inputs[i]).val()) == "" ||
            $(inputs[i]).val() == $(inputs[i]).attr("default-value"))
        ) {
          ok = false;
          $(inputs[i]).addClass("input-error");
        } else if (
          !FORMS.checkText($(inputs[i]).val(), $(inputs[i]).attr("input-type"))
        ) {
          ok = false;
          $(inputs[i]).addClass("input-error");
        } else if (
          $(inputs[i]).attr("minlength") != null &&
          $(inputs[i]).val().length < Number($(inputs[i]).attr("minlength"))
        ) {
          ok = false;
          $(inputs[i]).addClass("input-error");
        } else if (
          $(inputs[i]).attr("maxlength") != null &&
          $(inputs[i]).val().length > Number($(inputs[i]).attr("maxlength"))
        ) {
          ok = false;
          $(inputs[i]).addClass("input-error");
        } else {
          $(inputs[i]).removeClass("input-error");
        }

        if (
          $(inputs[i]).attr("type") == "radio" &&
          $(inputs[i]).attr("mandatory") == 1
        ) {
          var radio_name = $(inputs[i]).attr("name");
          if (
            $(form_id + " input[name=" + radio_name + "]:checked").val() == null
          ) {
            ok = false;
            $(form_id + " input[name=" + radio_name + "]").addClass(
              "input-error"
            );
          } else {
            $(form_id + " input[name=" + radio_name + "]").removeClass(
              "input-error"
            );
          }
        } else if (
          $(inputs[i]).attr("type") == "checkbox" &&
          $(inputs[i]).attr("mandatory") == 1
        ) {
          if ($(inputs[i]).attr("data-group") != null) {
            // multiple checkbox option
            var checkbox_group = $(inputs[i]).attr("data-group");
            if (
              $(
                form_id + " input[data-group=" + checkbox_group + "]:checked"
              ).val() == null
            ) {
              ok = false;
              $(form_id + " input[data-group=" + checkbox_group + "]").addClass(
                "input-error"
              );
            } else {
              $(
                form_id + " input[data-group=" + checkbox_group + "]"
              ).removeClass("input-error");
            }
          } else {
            // single checkbox option
            if ($(inputs[i]).prop("checked") == false) {
              ok = false;
              $(inputs[i]).addClass("input-error");
            } else $(inputs[i]).removeClass("input-error");
          }
        }
      }
    }

    if (!ok) {
      if (msg_id != "") {
        FORMS.showUserMessage(
          TOKEN.VALIDATE_FIELDS,
          FORMS.MESSAGE_ERROR,
          msg_id,
          false
        );
      } else {
        alert(error_tf);
      }
    }

    return ok;
  },

  getData: function(form_id) {
    var args = {};
    var inputs = $(form_id).find(":input");
    for (var i = 0; i < inputs.length; i++) {
      var name_field = $(inputs[i]).attr("name");

      if (name_field != undefined) {
        if (
          $(inputs[i]).attr("type") == "radio" ||
          $(inputs[i]).attr("type") == "checkbox"
        )
          args[name_field] = $(
            "input[name=" + $(inputs[i]).attr("name") + "]:checked",
            form_id
          ).val();
        else args[name_field] = UTILS.trim($(inputs[i]).val());
      }
    }

    //return JSON.stringify(args);
    return args;
  },

  showUserMessage: function(msg, type, msg_selector, use_icon) {
    if (type == undefined) type = FORMS.MESSAGE_OK;
    if (msg_selector == undefined) msg_selector = ".form-message";

    if (use_icon) {
      if (type == FORMS.MESSAGE_OK)
        msg = FORMS.getSuccessAnimationIcon() + "<div>" + msg + "</div>";
      else {
        msg = FORMS.getErrorAnimationIcon() + "<div>" + msg + "</div>";
      }

      UTILS.slideTo(msg_selector, 0);
    }
    $(msg_selector)
      .removeClass(FORMS.MESSAGE_ERROR)
      .removeClass(FORMS.MESSAGE_OK)
      .addClass(type)
      .html(msg);
  },

  getFilesInFormData: function(form_name) {
    var formData = new FormData();
    var inputs = $(form_name).find(":input");
    var has_files = false;
    for (var i = 0; i < inputs.length; i++) {
      if ($(inputs[i]).attr("type") == "file") {
        if ($(inputs[i])[0].files != null && $(inputs[i])[0].files.length > 0) {
          formData.append($(inputs[i]).attr("name"), $(inputs[i])[0].files[0]);
          has_files = true;
        }
      }
    }
    if (has_files) return formData;
    else return false;
  },

  sendForm: function(
    event,
    form_name,
    endpoint,
    extra_validation,
    ok_callback,
    error_callback,
    use_icon,
    force_form_data
  ) {
    event.preventDefault();
    var form_message = form_name + " .form-message";

    if($(form_message).length == 0)
    {
      form_message = form_name + "-message";
    }

    var is_valid = FORMS.validateForm(form_name, form_message);
    if (!is_valid) return;

    if (extra_validation != undefined) {
      var extra = extra_validation.call(form_name);
      if (!extra) return;
    }

    var form = $(form_name);
    UTILS.blockUI(true);
    var args = FORMS.getData(form_name);
    args["csrf"] = form.attr("data-csrf");
    args["form_code"] = form.attr("data-id");

    var has_files = FORMS.getFilesInFormData(form_name);
    var form_data = new FormData();
    var headers = {};
    if (has_files) {
      form_data = has_files;
    }
    if (has_files || force_form_data == true) {
      for (var prop in args) {
        form_data.append(prop, args[prop]);
      }

      headers = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };

      args = form_data;
    }

    axios
      .post("/requests/" + endpoint, args, headers)
      .then(function(response) {
        if (response.data.message != undefined && response.data.message != "") {
          FORMS.showUserMessage(
            response.data.message,
            FORMS.MESSAGE_OK,
            form_message,
            use_icon
          );
        } else {
          FORMS.showUserMessage(
            TOKEN.FORM_GENERIC_OK,
            FORMS.MESSAGE_OK,
            form_message,
            use_icon
          );
        }

        if (
          response.data.data.token != undefined &&
          response.data.data.token != ""
        )
          form.attr("data-csrf", response.data.data.token);

        if (ok_callback != undefined) ok_callback.call(this, response);
      })
      .catch(function(error) {
        if (
          error &&
          error.response &&
          error.response.data.message != undefined &&
          error.response.data.message != ""
        ) {
          FORMS.showUserMessage(
            error.response.data.message,
            FORMS.MESSAGE_ERROR,
            form_message,
            use_icon
          );
        } else {
          FORMS.showUserMessage(
            TOKEN.FORM_GENERIC_ERROR,
            FORMS.MESSAGE_ERROR,
            form_message,
            use_icon
          );
        }

        if (
          error.response.data &&
          error.response.data.data &&
          error.response.data.data.token
        )
          form.attr("data-csrf", error.response.data.data.token);

        if (error_callback != undefined)
          error_callback.call(this, error.response);
      })
      .finally(function() {
        UTILS.blockUI(false);
      });
  },

  getSuccessAnimationIcon: function() {
    return `
			<div class="svg-box">
				<svg class="circular green-stroke">
						<circle class="path" cx="75" cy="75" r="50" fill="none" stroke-width="5" stroke-miterlimit="10"/>
				</svg>
				<svg class="checkmark green-stroke">
						<g transform="matrix(0.79961,8.65821e-32,8.39584e-32,0.79961,-489.57,-205.679)">
								<path class="checkmark__check" fill="none" d="M616.306,283.025L634.087,300.805L673.361,261.53"/>
						</g>
				</svg>
			</div>`;
  },

  getErrorAnimationIcon: function() {
    return `
		<div class="svg-box">
			<svg class="circular red-stroke">
					<circle class="path" cx="75" cy="75" r="50" fill="none" stroke-width="5" stroke-miterlimit="10"/>
			</svg>
			<svg class="cross red-stroke">
					<g transform="matrix(0.79961,8.65821e-32,8.39584e-32,0.79961,-502.652,-204.518)">
							<path class="first-line" d="M634.087,300.805L673.361,261.53" fill="none"/>
					</g>
					<g transform="matrix(-1.28587e-16,-0.79961,0.79961,-1.28587e-16,-204.752,543.031)">
							<path class="second-line" d="M634.087,300.805L673.361,261.53"/>
					</g>
			</svg>
		</div>`;
  },

  getWarningAnimationIcon: function() {
    return `
		<div class="svg-box">
			<svg class="circular yellow-stroke">
					<circle class="path" cx="75" cy="75" r="50" fill="none" stroke-width="5" stroke-miterlimit="10"/>
			</svg>
			<svg class="alert-sign yellow-stroke">
					<g transform="matrix(1,0,0,1,-615.516,-257.346)">
							<g transform="matrix(0.56541,-0.56541,0.56541,0.56541,93.7153,495.69)">
									<path class="line" d="M634.087,300.805L673.361,261.53" fill="none"/>
							</g>
							<g transform="matrix(2.27612,-2.46519e-32,0,2.27612,-792.339,-404.147)">
									<circle class="dot" cx="621.52" cy="316.126" r="1.318" />
							</g>
					</g>
			</svg>
		</div>`;
  }
};
